import { render } from "./iconCintaAzul.vue?vue&type=template&id=41829f15&scoped=true"
import script from "./iconCintaAzul.vue?vue&type=script&lang=js"
export * from "./iconCintaAzul.vue?vue&type=script&lang=js"

import "./iconCintaAzul.vue?vue&type=style&index=0&id=41829f15&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41829f15"

export default script